import type { GetExploreContent200PageAllOfThreeContentItem } from './getExploreContent200PageAllOfThreeContentItem';

export type GetExploreContent200PageAllOfThree = {
  content?: GetExploreContent200PageAllOfThreeContentItem[];
};
